<template>
    <dropdown class="mr-8 md:mr-0" placement="bottom-end" :auto-close="false">
        <template #default>
          <span class="cursor-pointer mr-8 relative">
            <font-awesome-icon icon="fa-regular fa-bell" size="2xl" class="text-blue-500" :class="'group-hover:text-white'" />
            <span class="text-white bg-red-600 rounded-full text-center w-5 text-[10px] absolute -right-1/3 -bottom-2">{{ notifications.length }}</span>
          </span>
        </template>
        <template #dropdown>
            <div class="mt-2 bg-white rounded shadow-xl w-72 lg:w-80">
              <div class="text-center uppercase py-3 border-b">Notificações</div>
              <div class="pt-3 max-h-[calc(100vh-150px)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200">
                <div class="p-3">
                  <div v-if="this.notifications.length" class="mb-3 pb-3 border-b" v-for="(notification, index) in this.notifications">
                    <div class="text-xs text-gray-500">{{ this.$filters.formatDateTime(notification.created_at) }}</div>
                    <div class="flex flex-nowrap items-center justify-between">
                      <div class="text-md">{{ notification.data.title }}</div>
                      <div class="text-xs text-gray-500"><font-awesome-icon icon="fa-circle-check" class="text-blue-600 cursor-pointer" @click.prevent="markAsRead(notification)" /></div>
                    </div>
                    <div class="text-sm text-gray-500">{{ notification.data.body }}</div>
                  </div>
                  <div v-else class="text-sm text-gray-500 mb-3">
                    Nenhuma notificação
                  </div>
                </div>
              </div>
            </div>
        </template>
    </dropdown>
</template>
<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import Dropdown from '@/Shared/Dropdown'

export default {
  data() {
    return {
      notifications: [],
      interval: null
    }
  },
  components: {
    Dropdown,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted() {

  },
  methods: {
    loadNotifications() {
      fetch(
        `/notifications`
      ).then(res => {
        res.json().then(json => {
          this.notifications = json.notifications;
        });
      });
    },
    markAsRead(notification) {
      this.notifications = this.notifications.filter((n) => notification.id != n.id);
      fetch(
        `/notifications/mark-read/` + notification.id
      ).then(res => {
        res.json().then(json => {
          
        });
      });
    }
  },
  mounted() {
    this.loadNotifications();
    this.interval = setInterval(this.loadNotifications, 60000)
  },
  unmounted() {
    clearInterval(this.interval);
  },
}
</script>